module.exports = __webpack_public_path__ + "static/media/korn.bf89e271.jpeg";